import { render, staticRenderFns } from "./X-infos-chantier.vue?vue&type=template&id=3a6a4a16&scoped=true"
import script from "./X-infos-chantier.vue?vue&type=script&lang=js"
export * from "./X-infos-chantier.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a6a4a16",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/bitnami/deploy/oscar_front/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3a6a4a16')) {
      api.createRecord('3a6a4a16', component.options)
    } else {
      api.reload('3a6a4a16', component.options)
    }
    module.hot.accept("./X-infos-chantier.vue?vue&type=template&id=3a6a4a16&scoped=true", function () {
      api.rerender('3a6a4a16', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/chantier/info_chantier/X-infos-chantier.vue"
export default component.exports